









import Vue from "vue";
import { VContainer } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { castComponent } from "@/lib/helpers";
import BaseSlowConnection from "@/components/BaseSlowConnection";

Vue.component("VContainer", castComponent(VContainer));
Vue.component("BaseSlowConnection", castComponent(BaseSlowConnection));

export default defineComponent({
  name: "BasePageOneColumn",
  props: {
    isLoading: { type: Boolean, default: false },
    noDescription: { type: Boolean, default: false },
  },
});
